import React, { useEffect, useState } from "react";
import { MuiBox, MuiTypography } from "components/atoms";
import { useTranslation } from "react-i18next";

function ContentLoading() {
  const [dots, setDots] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length === 5 ? "" : prev + "."));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <MuiBox
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        minHeight: 200,
      }}
    >
      <MuiTypography variant="16" color="text.darkBlack" fontWeight="500">
        {t("common.loading")}
        <span
          style={{
            display: "inline-block",
            width: "1.5em",
            textAlign: "left",
          }}
        >
          {dots}
        </span>
      </MuiTypography>
    </MuiBox>
  );
}

export default ContentLoading;
